// Libraries
import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */

/**
 * @class TextToggleController
 * @extends Controller
 * @description Toggles the text content of an element.
 */
class TextToggleController extends Controller {
    static values = { text: String };

    /**
     * @method toggleText
     * @description Toggles the text content of an element.
     *
     * @returns {void}
     */
    toggleText() {
        const newText = this.textValue;
        const oldText = this.element.textContent;

        this.textValue = oldText;
        this.element.textContent = newText;
    }
}

// Exports
export default TextToggleController;
